export interface PackageShortInfo {
    PackageID:            number;
    ProductInfoURL:       string;
    ProductPreferredName: string | null;
    PictureThumbnailURL:  string;
}